   <!-- Note: Do not use [disabled] on angular form controls
        check the method updateFormDisabledState() -->
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

    <p-toolbar>
      <ng-template #start>
        <div class="flex gap-4 toolbar-menu">
          <div class="flex flex-col">
            <label class="mr-2" for="ods">Pipe OD Filter ({{ diameterUnit }}) </label>
            <p-select inputId="ods" placeholder="View All" (onChange)="filterByOd($event)" [options]="filterPipeOds" appendTo="body" title="Pipe OD ({{ diameterUnit }})">
            </p-select>
          </div>
            <app-scope-filter 
              [(selectedFilter)]="selectedScopeFilter"
              [userRoles]="userRoles"
              (filterChange)="onScopeFilterChange()">
            </app-scope-filter>
        </div>
      </ng-template>
      <ng-template #end>
        <span class="text-sm mr-2">* NOTE: External pressure rating is based on leakage from outside</span> 
      </ng-template>
    </p-toolbar>
    
    @if (!isLoading()) {
    <form [formGroup]="connectionsForm" novalidate>
      <ng-container formArrayName="connections">
        <p-table
          styleClass="p-datatable-sm pr-2"
          #catalogTable
          [appAutoTableHeight]="true"
          [appAutoTableHeightContainerSelector]="'.grid-stack-item-content'"
          [appAutoTableHeightOffset]="120"
          (appAutoTableHeightChange)="tableHeight = $event"
          [columns]="columnDefs"
          [scrollable]="true"
          [scrollHeight]="tableHeight"
          [resizableColumns]="false"
          [value]="connectionsCatalog.controls" 
          dataKey="value.id" 
          stateStorage="local" 
          [first]="paginatorFirst()"
          (firstChange)="paginatorFirst.set($event)"
          (onPage)="onPageChange($event)"
          showGridlines
          [paginator]="true"
          [rows]="rows"
          [rowsPerPageOptions]="[10, 15, 20, 25]"
          paginatorPosition="top"
          paginatorDropdownAppendTo="body"
        paginatorStyleClass="!py-1 !text-xs [&_button]:!min-w-7 [&_button]:!h-7 [&_.p-select]:!h-7 [&_.p-select-label]:!py-0 [&_.p-select-label]:!leading-7"
          [stateKey]="componentId">
          <ng-template pTemplate="header">
            <!-- Group Headers -->
            <!-- NOTE: Complex header layout breaks [resizableColumns], so we have to add pResizableColumn manually -->
            <tr class="bg-gray-50 dark:bg-gray-800">
              <th pResizableColumn colspan="2" rowspan="2" class="text-center border-gray-400/90 dark:border-gray-500/90">Name</th>

              <!-- Pipe -->
              <th pResizableColumn colspan="2" class="text-center border-gray-400/90 border-gray-500/90">Pipe</th>

              <!-- Conn -->
              <th pResizableColumn colspan="7" class="text-center border-gray-400/90 border-gray-500/90">Connection</th>

              <th pResizableColumn rowspan="2" class="text-center border-gray-400/90 border-gray-500/90">CQE</th>

              @if (userRoles?.catalogAdmin) {
              <th pResizableColumn rowspan="2" class="text-center border-gray-400/90 border-gray-500/90">Scope</th>
              }

              <th pResizableColumn rowspan="2" class="text-center border-gray-400/90 border-gray-500/90">
                <div class="flex justify-center gap-1">
                  <p-button class="outlined-button" severity="success" outlined="true" size="small"
                    icon="pi pi-plus" (click)="onAddConnection()" title="Add Connection"></p-button>
                  <p-button severity="success" text size="small" icon="pi pi-file-excel"
                    [disabled]="connectionsCatalog.invalid"
                    (click)="exportExcel()" title="Export to Excel"></p-button>
                </div>
              </th>
            </tr>

            <!-- Sub-Headers -->
            <tr class="bg-gray-50">
            
              <!-- Pipe -->
              <th pResizableColumn class="text-center border-gray-500/90">Pipe OD ({{ diameterUnit }})</th>
              <th pResizableColumn class="text-center border-gray-500/90">Pipe ({{ diameterUnit }}, {{ weightUnit }})</th>

              <!-- Conn -->
              <th pResizableColumn class="text-center border-gray-500/90">OD ({{ diameterUnit }})</th>
              <th pResizableColumn class="text-center border-gray-500/90">ID ({{ diameterUnit }})</th>
              <th pResizableColumn class="text-center border-gray-500/90">Grade</th>
              <th pResizableColumn class="text-center border-gray-500/90">Burst Rating ({{ pressureUnit }})</th>
              <th pResizableColumn class="text-center border-gray-500/90">Collapse Rating * ({{ pressureUnit }})</th>
              <th pResizableColumn class="text-center border-gray-500/90">Tension Rating ({{ forceUnit }})</th>
              <th pResizableColumn class="text-center border-gray-500/90">Compression Rating ({{ forceUnit }})</th>  
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-connFg let-rIdx="rowIndex">
            <ng-container [formGroupName]="rIdx">
              <tr class="hover:bg-gray-500 transition-colors duration-100"
                [class.catalog-duplicate-row]="duplicateRowColors().has(connFg.get('id').value)"
                [style.background-color]="duplicateRowColors().get(connFg.get('id').value) ?? null">
                <td class="text-center">
                  <app-catalog-metadata-icon [metadata]="connFg.value.metadata"></app-catalog-metadata-icon>
                </td>
                <td>
                  <div
                    class="block"
                    (mouseenter)="setHoverTitle($event, !isControlInvalid(connFg, 'name') ? showJson(connFg.get('name').value) : getControlErrors(connFg, 'name'))"
                  >
                    <input type="text" pInputText formControlName="name" autocomplete="off"/>
                  </div>
                </td>
                <td>
                  <app-units-select-input
                    class="truncate-select"
                    formControlName="pipeOd"
                    [unit]="diameterUnit"
                    [unitPrecisionOverrides]="pipeDimensionPrecisionOverrides()"
                    optionLabel="value"
                    optionValue="value"
                    [options]="pipeOds"
                    [placeholder]="getPipeOdPlaceholder(connFg.get('tubularPipe').value)"
                    appendTo="body"
                    ariaLabel="Pipe OD ({{ diameterUnit }})">
                  </app-units-select-input>
                </td>
                <td class="text-center">
                  <div
                    class="block"
                    (mouseenter)="setHoverTitle($event, showJson(connFg.get('tubularPipe').value))"
                  >
                    <app-units-select-input
                      class="truncate-select"
                      formControlName="tubularPipe"
                      [optionLabelFormatter]="formatPipeLabel"
                      [options]="getSortedPipeOptions(connFg, 'weightPerFoot')"
                      [placeholder]="getPipePlaceholder(connFg.get('tubularPipe').value)"
                      appendTo="body"
                      ariaLabel="Pipe ({{ diameterUnit }}, {{ weightUnit }})">
                    </app-units-select-input>
                  </div>
                </td>
                <td class="text-right">
                  <p-inputNumber formControlName="outerDiameter" [minFractionDigits]="3"
                    [title]="!isControlInvalid(connFg, 'outerDiameter') ? 'Connection OD (' + diameterUnit + ')' : getControlErrors(connFg, 'outerDiameter')"></p-inputNumber>
                </td>
                <td class="text-right">
                  <p-inputNumber formControlName="innerDiameter" [minFractionDigits]="3"
                    [title]="!isControlInvalid(connFg, 'innerDiameter') ? 'Connection ID (' + diameterUnit + ')' : getControlErrors(connFg, 'innerDiameter')"></p-inputNumber>
                </td>
                <td class="text-center">
                  <div
                    class="block"
                    (mouseenter)="setHoverTitle($event, isControlInvalid(connFg, 'grade') ? getControlErrors(connFg, 'grade') : showJson(connFg.get('grade').value))"
                  >
                    <p-select class="truncate-select"  filter filterBy="label" resetFilterOnHide="true"
                      [placeholder]="getPlaceholderText(connFg.get('grade').value, 'name')"
                      formControlName="grade" [options]="grades" appendTo="body"></p-select>
                  </div>
                </td>
                <td class="text-right">
                  <p-inputNumber [minFractionDigits]="1" formControlName="burstRating" required
                    [title]="!isControlInvalid(connFg, 'burstRating') ? 'Burst Rating (' + pressureUnit + ')' : getControlErrors(connFg, 'burstRating')"></p-inputNumber>
                </td>
                <td class="text-right">
                  <p-inputNumber [minFractionDigits]="1" formControlName="collapseRating"
                    [title]="!isControlInvalid(connFg, 'collapseRating') ? 'Collapse Rating (' + pressureUnit + ')' : getControlErrors(connFg, 'collapseRating')"></p-inputNumber>
                </td>
                <td class="text-right">
                  <p-inputNumber [maxFractionDigits]="3" [minFractionDigits]="1" formControlName="tensionRating"
                    [title]="!isControlInvalid(connFg, 'tensionRating') ? 'Tension Rating (' + forceUnit + ')' : getControlErrors(connFg, 'tensionRating')"></p-inputNumber>
                </td>
                <td class="text-right">
                  <p-inputNumber [maxFractionDigits]="3" [minFractionDigits]="1" formControlName="compressionRating"
                    [title]="!isControlInvalid(connFg, 'compressionRating') ? 'Compression Rating (' + forceUnit + ')' : getControlErrors(connFg, 'compressionRating')"></p-inputNumber>
                </td>
                <td class="catalog-row-cqe">
                  <div class="flex items-center">
                  <p-button class="outlined-button" severity="info" outlined="true" size="small"
                    icon="pi pi-pencil" (click)="openTleDialog(connFg)" title="Edit CQE"></p-button>
                  @if (checkTleDataExists(rIdx)) {
                  <i
                     title="This connection has CQE data." 
                     class="pi pi-check-circle !text-green-500 ml-1"></i>
                  }
                  </div>
                </td>
                @if (userRoles?.catalogAdmin) {
                <td>
                  <div class="flex justify-center">
                  @if (!connFg.get('isLocked').value) {
                  <p-button
                    [label]="getScopeLabel(connFg.get('scope').value)"
                    [severity]="connFg.get('scope').value === CatalogScope.Global ? 'success' : 'info'"
                    size="small"
                    outlined="true"
                    class="outlined-button"
                    (click)="toggleScope(connFg)"
                    [title]="'Click to switch to ' + (connFg.get('scope').value === CatalogScope.User ? 'Global' : 'User')"
                  ></p-button>
                  } @else {
                  <span class="text-sm text-gray-500">Global</span>
                  }
                  </div>
                </td>
                }
                <td class="text-center">
                  @if (!deleteConnectionCheck(connFg)) {
                  <i
                     title="Delete Connection" 
                     class="pi pi-trash !text-red-400 cursor-pointer" 
                     (click)="onDeleteConnection(rIdx)"></i>
                  } @else {
                  <i
                     title="Locked catalog item, cannot be deleted." 
                     class="pi pi-lock text-gray-400"></i>
                  }
                </td>
              </tr>
            </ng-container>
          </ng-template>
        </p-table>
      </ng-container>
    </form>
    }

    @if (!isLoadingCqe()) {
    <p-dialog
      [styleClass]="'popup-dialog'"
      header="Connection Qualification Envelope (CQE) Data"
      [(visible)]="tleDialogVisible"
      [modal]="true"
      [style]="{ width: '600px', height: '500px', 'position': 'fixed' }"
      appendTo="body"
      closable="false"
    >
      <p-selectButton [options]="tleTablePlot" [(ngModel)]="tleTablePlotSelected"
        (onChange)="tablePlotToggle()" [allowEmpty]="false">
      </p-selectButton>
      @if (tleTablePlotSelected === 'table') {
      <br>
      <br>

      <label>If the CQE is specified after the connection has been selected in the Well Configuration, it must be re-selected</label>
      }

      @if (tleTablePlotSelected == 'table') {
      <app-units-grid-input
        [tableTitle]="'Connection CQE Data'"
        [rows]="tleProfileRows"
        [columns]="tleColumns"
        [enableScroll]="true"
        [scrollHeight]="'330px'"
        [allowDeleteRows]="true"
        [minRows]="1"
        [createRow]="createTleRow"
        [dedupePasteByFirstColumn]="false"
        [sortPasteByFirstColumn]="false"
        [commitMode]="'debounced'"
        [commitDebounceMs]="300"
        (cellEdited)="onTleCellEdited()"
        (rowDeleted)="onTleRowDeleted($event)"
        (rowsReset)="onTleRowsReset()"
        (pasteApplied)="onTleGridCommit()"
        (commitRequested)="onTleGridCommit()"
      ></app-units-grid-input>
      }

      @if (tleTablePlotSelected === 'plot') {
      <app-xy-line-plot
        [plotData]="plot.data"
        class="h-[420px]"
        [xAxisTitle]="xAxisTitle" 
        [yAxisTitle]="yAxisTitle" 
        [plotName]="'Connection CQE Plot'" 
        [downloadPlotName]="'Connection_CQE_Plot'"
        [reverseAutoRange]="true"
        [plotTitle]="'Connection CQE Plot'"
      ></app-xy-line-plot>
      }

      <ng-template pTemplate="footer">
        <div class="pb-2">
          <button
            pButton
            type="button"
            icon="pi pi-times"
            class="p-button-text p-button-danger text-xs"
            label="Cancel"
            (click)="onCloseTleDialog()"
          ></button>

          <button
            pButton
            type="button"
            icon="pi pi-check"
            class="p-button-text p-button-success text-xs"
            label="Save"
            (click)="saveTleData()"
          ></button>
        </div>
         
      </ng-template>

    </p-dialog>
}

  </app-tool-loader>
